import React, { useEffect, useState }  from "react"
import Label from "../atoms/Label"
import { markdownToJSX } from "../../util/transforms"
import showModal from "./Modal"
import Icon from "../atoms/Icon"
import useSiteData from "../../useSiteData"
import Link from "../atoms/Link"

export default ({ label, title, price, listTitle = "Included per week", list, isFeatured, link, seeAllText = "See everything included", expanded=false, disableBookButton=false, travelizeProductCode=false }) => {
  const { translations } = useSiteData().pageSettings
  const blogSlug = useSiteData().blogSlug
  const openModal = () => showModal({ children: <Pricing showAll/>, translations, blogSlug: blogSlug })
  
  const slug = useSiteData().checkoutSlug
  const [bookingLink, setBookingLink] = useState( false )

    useEffect(() => {
    // set bookingLink if we have a product code and a booking link should be included
    if( !disableBookButton && travelizeProductCode ) {
      setBookingLink( { internalLink: { slug }, anchor: { anchorName: travelizeProductCode.toUpperCase() } } )
    }

  }, [travelizeProductCode] )

  // override default link title if seeAllText is set in the CMS
  if( link && seeAllText != "See everything included" ) {
    if( link.contentType == "itemGalleryLink" ) {
      link.linkText = seeAllText
    } else {
      link.title = seeAllText
    }
  }

  const Pricing = ({ showAll = false }) => (
    <div className={ "o-pricing" + (isFeatured ? " o-pricing--featured u-background-blue" : "") + 
                      (showAll || expanded ? " o-pricing--show-all" : "") + 
                      ( link ? " o-pricing--link" : "" ) }>
      <Label text={ label } classes="o-pricing__label"/>
      <div className="o-pricing__title heading heading--fsm">{ title }</div>
      <p className="o-pricing__price u-small-text">{ markdownToJSX(price) }</p>
      <div className="o-pricing__list u-small-text">
        <p className="o-pricing__desc">{ listTitle }</p>
        <ul className="u-list-unstyled">
          { list && list.map((item, index) => (
            <li className="o-pricing__item" key={ index }>
              <Icon className="o-pricing__icon a-icon a-icon--s" iconName="icon-check"/>
              { item }
            </li>
          )) }          
        </ul>
        { ( bookingLink && (showAll || expanded) ) &&
          <div className="o-pricing__book-button">
            <Link className="a-btn a-btn--red" link={ bookingLink } translations={ translations } >
              { (translations.book ? translations.book : "Book") }
            </Link>
          </div>
        }
      </div>
      { link &&
        <div className="o-pricing__more u-small-text">
          <Link link={ link } translations={ translations } />
        </div>
      }
      { (!showAll && !link && !expanded) &&
        <div className="o-pricing__more u-small-text">
          <button className="o-pricing__more-btn a-btn a-btn--transparent" onClick={ openModal }>
            { seeAllText }
          </button>
        </div>
      }      
    </div>
  );

  return <Pricing showAll={ link ? true : false }/>
}
